function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M60 30c0 16.568-13.432 30-30 30C13.432 60 0 46.568 0 30 0 13.432 13.432 0 30 0c16.568 0 30 13.432 30 30",
  fill: "#06B0E4"
}), React.createElement("g", {
  fill: "#7FD2ED"
}, React.createElement("path", {
  d: "M30 20.333c2.125 0 3.75-1.625 3.75-3.75 0-2-1.625-3.75-3.75-3.75-2 0-3.75 1.625-3.75 3.75s1.75 3.75 3.75 3.75M30.125 23.583c-2.375 0-3.625 1.25-3.625 3.625v17c0 2.375 1.25 3.625 3.625 3.625s3.625-1.25 3.625-3.625v-17c0-2.375-1.25-3.625-3.625-3.625"
})));

var SvgIconCircleInfo = function SvgIconCircleInfo(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgIconCircleInfo;